/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  const reviewWidgetSelector = '[data-review-widget]';
  const reviewWidgetWrapperSelector = '[data-review-widget-wrapper]';
  const reviewCountSelector = [
    '[data-review-count]',
    '[data-reviews-count]',
    '[data-total-reviews]',
    '.yotpo-sr-bottom-line-text',
    '.yotpo-reviews-count',
    '.yotpo-review-count',
  ].join(',');
  const reviewCountPattern = /(?:^|[^\d])(\d[\d\s,.\u00a0]*)\s*(?:reviews?|ratings?|bewertungen?|reseñas?|comentarios?|opiniones?|valoraciones?|avis|critiques?|commentaires?|évaluations?|recensioni|valutazioni?|avaliações?)(?=$|[^\p{L}])/iu;
  const pdpValueLabelSelector = '[data-pdp-value-label]';
  let scanFrame = null;

  const parseReviewCount = (value) => {
    const match = value && value.match(reviewCountPattern);

    if (!match) {
      return null;
    }

    return parseInt(match[1].replace(/[\s,.\u00a0]/g, ''), 10);
  };

  const getReviewCount = (widget) => {
    const countElements = widget.querySelectorAll(reviewCountSelector);

    for (let index = 0; index < countElements.length; index += 1) {
      const count = parseReviewCount(countElements[index].textContent.trim());

      if (count !== null) {
        return count;
      }
    }

    return parseReviewCount(widget.textContent.trim());
  };

  const updateReviewWidget = (wrapper) => {
    const widget = wrapper.querySelector(reviewWidgetSelector);

    if (!widget) {
      return;
    }

    const count = getReviewCount(widget);

    if (count === null) {
      return;
    }

    wrapper.hidden = count === 0;
    wrapper.setAttribute('data-review-widget-state', count === 0 ? 'hidden' : 'visible');
  };

  const scanReviewWidgets = () => {
    scanFrame = null;
    document.querySelectorAll(reviewWidgetWrapperSelector).forEach(updateReviewWidget);
  };

  const scheduleReviewWidgetScan = () => {
    if (scanFrame !== null) {
      return;
    }

    scanFrame = window.requestAnimationFrame
      ? window.requestAnimationFrame(scanReviewWidgets)
      : window.setTimeout(scanReviewWidgets, 0);
  };

  const updatePdpValueLabel = (event) => {
    const eventTarget = event.target;
    const productContainer = eventTarget.closest('[data-product]') || eventTarget.querySelector('[data-product]');
    const variant = event.detail && event.detail.variant;

    if (!productContainer || !variant) {
      return;
    }

    const showValueLabel = variant.compare_at_price > variant.price;

    productContainer.querySelectorAll(pdpValueLabelSelector).forEach((label) => {
      label.classList.toggle('hidden', !showValueLabel);
    });
  };

  const reviewObserver = new MutationObserver(() => {
    scheduleReviewWidgetScan();
  });

  reviewObserver.observe(document.body, {childList: true, subtree: true, characterData: true});
  scheduleReviewWidgetScan();
  document.addEventListener('theme:variant:change', updatePdpValueLabel);

  document.addEventListener('theme:filters:init', function() {
    setTimeout(() => {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      }

      scheduleReviewWidgetScan();
    }, 1500)
  });

  /* The theme conveys availability and cart feedback visually only — mirror it for screen readers. */
  var strings = (window.theme && window.theme.strings) || {};

  // Locale strings keep their {{ placeholders }} when rendered without arguments.
  function interpolate(template, data) {
    if (!template) return '';
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      return data[key] == null ? '' : data[key];
    });
  }

  var statusRegion = document.querySelector('[data-a11y-status]');

  function announce(message) {
    if (!statusRegion || !message) return;

    // Clearing first makes screen readers re-read an identical message.
    statusRegion.textContent = '';
    setTimeout(function () {
      statusRegion.textContent = message;
    }, 150);
  }

  /* VoiceOver reads the visible <label>, not the input's aria-label, so the sold-out state
     goes into the label; aria-label is kept in sync for readers that prefer it. */
  function availabilityState(wrapper) {
    if (wrapper.classList.contains('sold-out')) return strings.variant_sold_out_a11y || '';
    if (wrapper.classList.contains('unavailable')) return strings.variant_unavailable_a11y || '';
    return '';
  }

  function statusNode(label) {
    var node = label.querySelector('[data-a11y-availability]');

    if (!node) {
      node = document.createElement('span');
      node.className = 'visually-hidden';
      node.setAttribute('data-a11y-availability', '');
      label.appendChild(node);
    }

    return node;
  }

  function labelVariantAvailability() {
    var inputs = document.querySelectorAll('[data-single-option-selector]');

    inputs.forEach(function (input) {
      var wrapper = input.parentElement;
      var value = input.value;

      if (!wrapper || !value) return;

      var label = wrapper.querySelector('label');
      var state = availabilityState(wrapper);

      if (label) {
        statusNode(label).textContent = state ? ', ' + state : '';
      }

      if (state) {
        input.setAttribute('aria-label', value + ', ' + state);
      } else {
        input.removeAttribute('aria-label');
      }
    });
  }

  /* Liquid renders the selected value in the legend once and nothing refreshes it. */
  function syncOptionLegends() {
    document.querySelectorAll('[data-single-option-selector]:checked').forEach(function (input) {
      var fieldset = input.closest('fieldset');

      if (!fieldset) return;

      var legendValue = fieldset.querySelector('legend .radio__legend__label span');

      if (legendValue) {
        legendValue.textContent = ': ' + input.value;
      }
    });
  }

  var labelTimer = null;

  function scheduleLabelling() {
    if (labelTimer) return;

    // Not requestAnimationFrame: frames are paused in background tabs.
    labelTimer = setTimeout(function () {
      labelTimer = null;
      labelVariantAvailability();
      syncOptionLegends();
    }, 0);
  }

  // theme:variant:change fires before the sold-out classes are updated, so defer a tick.
  document.addEventListener('theme:variant:change', scheduleLabelling);

  // Quick view injects its own form after this script runs.
  var observedForms = [];

  function observeProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (observedForms.indexOf(form) !== -1) return;

      observedForms.push(form);
      new MutationObserver(scheduleLabelling).observe(form, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
      scheduleLabelling();
    });
  }

  new MutationObserver(observeProductForms).observe(document.documentElement, {
    subtree: true,
    childList: true,
  });

  observeProductForms();
  scheduleLabelling();

  /* Re-rendering the drawer after an add destroys the focused control and focus lands on
     <body>; the request timing varies, so watch for it instead of guessing a delay. */
  var drawerFocusTimer = null;

  function restoreDrawerFocus() {
    var attempts = 0;

    clearInterval(drawerFocusTimer);
    drawerFocusTimer = setInterval(function () {
      var drawer = document.querySelector('[data-cart-drawer]');

      attempts += 1;

      if (attempts > 40) {
        clearInterval(drawerFocusTimer);
        return;
      }

      if (!drawer || !drawer.classList.contains('is-open')) return;

      // Only when focus was lost, never when the user moved it somewhere else.
      if (document.activeElement !== document.body) return;

      var close = drawer.querySelector('.cart-drawer__close');

      if (close) {
        close.focus();
        clearInterval(drawerFocusTimer);
      }
    }, 100);
  }

  // theme:cart:added carries no product, so remember the control the user activated.
  var lastAddedTitle = '';

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-add-to-cart]') : null;

    if (button) {
      lastAddedTitle = button.getAttribute('data-atc-product-title') || '';
      restoreDrawerFocus();
    }
  }, true);

  document.addEventListener('theme:cart:added', function () {
    announce(lastAddedTitle
      ? interpolate(strings.added_to_cart_a11y, {title: lastAddedTitle})
      : strings.item_added_a11y);

    restoreDrawerFocus();
  });

  /* Help Scout Beacon sits at the end of the focus order; opening it must also take focus. */
  function focusBeacon() {
    var attempts = 0;

    var timer = setInterval(function () {
      var frame = document.querySelector('#beacon-container iframe, .BeaconContainer iframe');

      attempts += 1;

      if (frame) {
        clearInterval(timer);
        frame.setAttribute('tabindex', '0');
        frame.focus();
      } else if (attempts > 20) {
        clearInterval(timer);
      }
    }, 150);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-support-link]') : null;

    if (!trigger) return;

    event.preventDefault();

    if (typeof window.Beacon === 'function') {
      window.Beacon('open');
      focusBeacon();
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
